module.exports = __webpack_public_path__ + "static/media/Closed.7e8c636e.svg";